var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error animated-banner bg-danger"},[_c('span',{staticClass:"error__message",domProps:{"textContent":_vm._s(_vm.errorText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }